import DeliveryCountries from '../AddressStartDeliveryCountries';

const isValid = (fieldName, value, addressDefinitions = []) => {
  let validationArray;
  
  const fieldDefinition = addressDefinitions.length > 0 && addressDefinitions?.find(field => field.name === fieldName);
  
  if (!fieldDefinition) {
    return true;
  }
  
  if (typeof fieldDefinition.validate === 'function') {
    validationArray = [fieldDefinition.validate];
  } else {
    validationArray = [...fieldDefinition.validate];
  }
  
  const valueToValidate = fieldDefinition.validationCleaner
    ? fieldDefinition.validationCleaner(value) : value;
  
  const errors = validationArray?.map(validator => validator(valueToValidate))?.filter(Boolean) || [];

  return errors.length <= 0;
};

export default {
  validateCountry: selectedCountry => DeliveryCountries.getList()
    ?.map(country => country.code)
    ?.includes(selectedCountry),
  validatePostCode: (addressDefinitions, value) => isValid('postCode', value, addressDefinitions),
  validateState: (addressDefinitions, value) => isValid('county', value, addressDefinitions),
  validateTownCity: (addressDefinitions, value) => isValid('townCity', value, addressDefinitions),
};
